import { useSignal } from "@preact/signals";
import { LineSelection, PhaseLines, SelectableLine } from "./interfaces";

const toggle = (items: string[], id: string, checked: boolean) =>
    checked ? items.filter((item) => item !== id) : [...items, id];

// everything is selected by default, so only exclusions are stored
const useLineSelection = (): LineSelection => {
    const excludedPhases = useSignal<string[]>([]);
    const excludedLines = useSignal<string[]>([]);

    return {
        isPhaseOn: (id) => !excludedPhases.value.includes(id),
        isLineOn: (id) => !excludedLines.value.includes(id),
        togglePhase: (id, checked) =>
            (excludedPhases.value = toggle(excludedPhases.peek(), id, checked)),
        toggleLine: (id, checked) =>
            (excludedLines.value = toggle(excludedLines.peek(), id, checked)),
        getSelected: <Line extends SelectableLine>(
            phases: PhaseLines<Line>[],
        ) =>
            phases.flatMap(({ phase, lines }) =>
                excludedPhases.peek().includes(phase.id)
                    ? []
                    : lines.filter(
                          (line) => !excludedLines.peek().includes(line.id),
                      ),
            ),
    };
};

export default useLineSelection;
